import { getDocumentFields } from 'utils/helper';
import cn from 'classnames';
import ContentfulParser from 'components/BlogCommon/Article/ContentfulParser';
import styles from './styles.module.scss';

const Card = ({ data, type }) => {
  const { contentModules: [cardData] } = getDocumentFields(data, [
    'contentModules',
  ]);

  const {
    title,
    description,
    text,
  } = getDocumentFields(
    cardData,
    [
      'title',
      'description',
      'text',
    ],
  );

  const titleWords = title.split('|');

  return (
    <section className={cn(styles.section, styles[type])}>
      <div className={styles.container}>
        <article className={styles.card}>
          <div className={styles['card-sidebar']}>
            {title && (
              <h2 className={styles['card-title']}>
                {titleWords.map((word, i) => (
                  <span
                    key={i}
                    className={cn({ [styles.lastWord]: i + 1 === titleWords?.length })}
                  >
                    {word}
                  </span>
                ))}
              </h2>
            )}
            {description && (
              <p className={styles['card-description']}>{description}</p>
            )}
          </div>
          <div className={styles['item-list']}>
            <ContentfulParser document={text} />
          </div>
        </article>
      </div>
    </section>
  );
};

export default Card;
